import React from 'react'
import { Tweet } from 'react-twitter-widgets'
import WebYouTube from 'react-youtube'
import { TikTok } from "react-tiktok";
import { Block, PrensaEngine, Typography } from '@xprog/prensa'
import {
  getTweetId,
  getYoutubeVideoId,
  getYoutubePlaylistId,
  getTiktokId
} from './Embed.utils'
import { EmbedProps } from './Embed.types'
import Script from 'next/script';

const StyledDiv = PrensaEngine.styled('div', {
  minHeight: '400px',
  minWidth: '400px'
})

const Embed = (props: EmbedProps) => {
  const blockProps = {
    ...props?.customCssWrap,
    maxWidth: props?.isFullWidth ? '100%' : props?.customCssWrap?.maxWidth,
    width: props?.isFullWidth ? '100%' : props?.customCssWrap?.width
  }
  const slotTemplateCode = props.item.slotTemplateCode
  const hrefRegex = /<a.*?href="(.*?)".*?>/g
  const hrefRegexTwitter = /<a.+href="(.+?)">/gm
  const hrefMatch = hrefRegex.exec(slotTemplateCode)
  const hrefTwitterMatch = hrefRegexTwitter.exec(slotTemplateCode)

  let href = ''
  let hrefTwitter = ''
  if (hrefTwitterMatch && hrefTwitterMatch.length > 0) {
    hrefTwitter = hrefTwitterMatch[1]
  }
  if (hrefMatch && hrefMatch.length > 0) {
    href = hrefMatch[1]
  }
  const originalUrl = props?.item?.bodyParsed?.value || href
  if (hrefTwitter && hrefTwitter?.includes('twitter.com')) {
    const tweetId = getTweetId(hrefTwitter)
    if (tweetId) {
      return (
        <Block css={blockProps}>
          <Block css={{
            align: ['row', 'center', 'middle'],
            width: '100%'
          }}>
            <Tweet
              tweetId={tweetId}
              options={{ lang: 'pt', align: 'center', height: 800, width: 1000 }}
            />
          </Block>
        </Block>
      )
    }
  }
  if (originalUrl && originalUrl.includes('twitter.com')) {
    const tweetId = getTweetId(originalUrl)

    if (tweetId) {
      return (
        <Block css={blockProps}>
          <Block css={{
            align: ['row', 'center', 'middle'],
            width: '100%'
          }}>
            <Tweet
              tweetId={tweetId}
              options={{ lang: 'pt', align: 'center', height: 800, width: 1000 }}
            />
          </Block>
        </Block>
      )
    }
  }
  if (originalUrl && originalUrl.includes('youtube.com')) {
    let opts = {}
    const videoId = getYoutubeVideoId(originalUrl)
    if (originalUrl.includes('list=')) {
      const playlistId = getYoutubePlaylistId(originalUrl)
      opts = {
        playerVars: {
          listType: 'playlist',
          list: playlistId
        }
      }
    }
    return (
      <WebYouTube
        className='article-youtube-embed'
        videoId={videoId}
        opts={opts}
        style={{
          maxWidth: '960px',
          width: '100%'
        }}
      />
    )
  }
  if (originalUrl && originalUrl.includes('stories.opopular')) {
    return (
      <>
        <StyledDiv dangerouslySetInnerHTML={{ __html: `${props?.item?.bodyParsed?.value}` }}></StyledDiv>
      </>
    )
  }
  if (originalUrl && originalUrl.includes('instagram-media')) {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: `${props?.item?.bodyParsed?.value}` }}></div>
        <Script async src="https://www.instagram.com/embed.js" />
      </>
    )
  }
  if (originalUrl && originalUrl.includes('instagram.com')) {
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: `${props?.item?.slotTemplateCode}` }}></div>
        <Script async src="https://www.instagram.com/embed.js" />
      </>
    )
  }
  if (originalUrl && originalUrl.includes('tiktok.com')) {
    const url = getTiktokId(props.item.slotTemplateCode)
    return (
      <TikTok
        url={url}
      />
    )
  }

  // Regex para capturar todos os iframes no HTML
  const iframeRegex = /<iframe.*?src="(.*?)".*?<\/iframe>/g
  const iframes: string[] = []
  let match: RegExpExecArray | null

  if (slotTemplateCode && slotTemplateCode.includes('facebook.com')) {

    while ((match = iframeRegex.exec(slotTemplateCode)) !== null) {
      iframes.push(match[0])
    }

    if (iframes.length > 0) {
      return (
        <Block css={{ align: ['column', 'center', 'middle'], blockProps }}>
          {iframes.map((iframe, index) => {
            // Manipula o iframe para ajustar altura e largura
            const modifiedIframe = iframe
              .replace(/height="\d+"/, 'height="550"')

            return (
              <div
                key={index}
                dangerouslySetInnerHTML={{ __html: modifiedIframe }}
                style={{
                  marginBottom: '20px',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              />
            )
          })}
        </Block>
      )
    }
  }

  if (originalUrl && originalUrl.includes('<iframe')) {
    while ((match = iframeRegex.exec(originalUrl)) !== null) {
      iframes.push(match[0])
    }

    if (iframes.length > 0) {
      return (
        <Block css={blockProps}>
          {iframes.map((iframe, index) => (
            <div key={index} dangerouslySetInnerHTML={{ __html: iframe }} style={{ marginBottom: '20px' }} />
          ))}
        </Block>
      )
    }
  }

  return (
    <Block css={blockProps}>
      <Typography as={props.as} css={props.customCss} variant={props.variant}>
        {props.value || props.children}
      </Typography>
    </Block>
  )
}

Embed.defaultProps = {
  as: 'p',
  customCssWrap: {
    maxWidth: '960px',
    width: '100%',
    mb: '$8',
    px: '$0'
  },
  customCss: {
    fontFamily: '$secondary',
    px: '$0',
    py: '$0',
    width: '100%',
  },
  variant: 'default-heading-1xl'
}

export default Embed
